export default "__VITE_ASSET__Cu_6vXri__"